// src/components/PremiumSuccess.jsx
import { useContext, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import LeftMenu from "./menus/LeftMenu";
import HeaderBar from "./headers/HeaderBar";
import { useAuth } from "../context/AuthContext";

export default function PremiumSuccessDesktop() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("✅ User arrived on success page:", currentUser?.uid);
  }, [currentUser]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <LeftMenu />
      <Box sx={{ width: "90%", ml: 1 }}>
        <HeaderBar
          title={translate("PaymentSuccessTitle")}
          subtitle={translate("PaymentSuccessMessage")}
          showProjectSelect={false}
          userName={currentUser?.displayName}
          userRole="" // tu peux laisser vide ou passer le role
        />
        <Box
          sx={{
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 80, color: "success.main", mb: 2 }}
          />
          <Typography variant="h4" gutterBottom>
            {translate("PaymentSuccessTitle")}
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            {translate("PaymentSuccessMessage")}
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/app")}
          >
            {translate("GoToDashboard")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
